import classNames from "classnames";
import React from "react";
import "./IconButton.scss";

interface TIconButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: React.ReactElement;
    size?: number;
    ariaLabel: string;
}

export const IconButton = ({ icon, size, ariaLabel, ...props }: TIconButton) => {
    return (
        <button
            {...props}
            title={ariaLabel}
            className={classNames("c-icon-button", props.className)}
            aria-label={ariaLabel}
        >
            {React.cloneElement(icon, { size })}
        </button>
    );
};
